import React from "react";
import {Link} from "react-router-dom";

//import assets
import "../../assets/styles/headerStyles/headerLogo.scss";


export function HeaderLogo() {
    return <Link to={'/blogs'} className="header-logo">
        {/*<AppLogo/>*/}
        <div className="brand-name">Mane Blog</div>
    </Link>
}
